import React from 'react'
import Dropzone from 'react-dropzone'
import { DimmerLoader } from '../../../../views/components'
import styles from './BulkImportOptions.module.scss'

interface BulkImportOptionsProps {
  onCsvDownload: () => void
  onFileUpload: (files: File[]) => void
  isLoading: boolean
  file?: File
  isDisabled?: boolean
}

const BulkImportOptions = ({ onCsvDownload, onFileUpload, isLoading, isDisabled, file }: BulkImportOptionsProps) => {
  return (
    <div className={styles.root}>
      <div className={styles['download-buttons']}>
        <p>
          Bulk import invoices for utilities from a CSV file.{' '}
          <button onClick={onCsvDownload}>Download a CSV template</button> containing all your active leases, fill in
          the amounts and then upload the file below.
        </p>
      </div>

      <div className={styles.dropzone}>
        <DimmerLoader loading={isLoading} disabled={isDisabled}>
          <Dropzone onDrop={onFileUpload} multiple={false} style={null} className="drop-zone">
            <p>
              Drag and drop a CSV file here or <button>browse to choose a file</button>
            </p>
          </Dropzone>
        </DimmerLoader>
      </div>
    </div>
  )
}

export default BulkImportOptions
